// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 962 ? "home" : chunkId) + "." + {"570":"868de797","962":"802b76c3"}[chunkId] + ".css";
};